import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import usePrivateLink from "../../config/usePrivateLink";

// import usePrivateLink from "../../config/usePrivateLink";
// import { useNavigate, useLocation } from "react-router-dom";

// const AttendanceHeader = ({ data }) => {
//     const navigate = useNavigate();
//     const location = useLocation();

//     const tabs = [
//         {
//             id: "BanksAccountCreate",
//             title: "Student Today",
//             icon: "ri-user-follow-line",
//             path: "/attendance"
//         },


//         {
//             id: "BanksAccountList",
//             title: "Student Monthly",
//             icon: "ri-calendar-todo-line",
//             path: "/attendance_month"
//         },

//         {
//             id: "Admission",
//             title: "Staff Today",
//             icon: "ri-group-line",
//             path: "/staff_attendance"
//         },

//         {
//             id: "feeDeposit",
//             title: "Staff Monthly",
//             icon: "ri-calendar-2-line",
//             path: "/staff_month_attendance"
//         },

//         {
//             id: "feeFollowups",
//             title: "Demo Student Today",
//             icon: "ri-user-time-line",
//             path: "/demo_student"
//         },

//         {
//             id: "gatepass",
//             title: "Demo Student Monthly",
//             icon: "ri-calendar-event-line",
//             path: "/demo_month_student"
//         },

//         {
//             id: "biometric",
//             title: "Bio Metric Data",
//             icon: "ri-fingerprint-line",
//             path: "/attendance/biometric"
//         }
//     ];


//     return (
//         <div className="">

//             {/* ✅ Sidebar Menu */}
//             <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
//                 <h5 className="text-primary text-center p-2">{data}</h5>
//                 {tabs.map((tab) => {
//                     const isActive = location.pathname === tab.path;

//                     return (
//                         <button
//                             key={tab.id}
//                             className={`list-group-item list-group-item-action d-flex align-items-center ${isActive ? "active" : ""
//                                 }`}
//                             onClick={() => navigate(tab.path)}
//                         >
//                             <i className={`${tab.icon} me-2`} />
//                             {tab.title}
//                         </button>
//                     );
//                 })}
//             </div>

//             {/* ✅ Page Content */}
//         </div>
//     );
// };

// export default AttendanceHeader;




const AttendanceHeader = ({ data }) => {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();
  const location = useLocation();
const tabs = [
        {
            id: "BanksAccountCreate",
            title: "Student Today",
            icon: "ri-user-follow-line",
            path: "/attendance"
        },

        {
            id: "BanksAccountList",
            title: "Student Monthly",
            icon: "ri-calendar-todo-line",
            path: "/attendance_month"
        },


        {
            id: "feeFollowups",
            title: "Demo Student Today",
           icon: "ri-time-line",
            path: "/demo_student"
        },

        {
            id: "gatepass",
            title: "Demo Student Monthly",
            icon: "ri-calendar-event-line",
            path: "/demo_month_student"
        },
        {
            id: "biometricdevice",
            title: "Bio Metric Device",
            icon: "ri-calendar-event-line",
            path: "/attendance/biometricdevice"
        },

        {
            id: "biometric",
            title: "Bio Metric Data",
            icon: "ri-fingerprint-line",
            path: "/attendance/biometric"
        }
    ];


  const filteredTabs = tabs.filter((tab) => hasAccess(tab.path));


  return (
    <div className="">

      {/* ✅ Sidebar Menu */}
      <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
        <h5 className="text-primary text-center p-2">{data}</h5>
        {filteredTabs.length === 0 && (
          <div className="text-center text-danger">You don't have permission to access any tabs.</div>
        )}
        {filteredTabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const permission = hasAccess(tab.path);

          return (
            <button
              key={tab.id}
              className={`list-group-item list-group-item-action d-flex align-items-center ${isActive ? "bg-label-primary" : ""} ${!permission ? "disabled-tab" : ""}`}
              onClick={() => permission && navigate(tab.path)}
              style={{
                cursor: permission ? "pointer" : "not-allowed",
                color: !permission ? "red" : "inherit",
                backgroundColor: !permission ? "#f8d7da" : "inherit",
              }}
              disabled={!permission}
            >
              <i className={`${tab.icon} me-2`} />
              {tab.title}
            </button>
          );
        })}
      </div>

      {/* ✅ Page Content */}
    </div>
  );
};

export default AttendanceHeader;

